module.exports = __webpack_public_path__ + "assets/img/tongji.8f2a3477.png";